interface ChipTextProps {
  text: string;
  color?: 'purple' | 'green';
  className?: string;
}

export default function ChipText({ text, color = 'purple', className = '' }: ChipTextProps) {
  const colorClasses = {
    purple: 'text-purple tracking-[0.0875rem]',
    green: 'text-green tracking-[0.2625rem]',
  };

  return (
    <p className={`font-inter-tight leading-[150%] uppercase font-[400] text-[1.75rem] mb-0 ${colorClasses[color]} ${className}`}>
      {text}
    </p>
  );
}
